import axiosClient from "@/libs/axiosClient";

export const removeFromGroup = (data) => {
    return axiosClient.post(`/table/rcm-slbs/update/removefromgroup`, data);
};

export const restartSlbMasterProcess = (data) =>{
    return axiosClient.post(`/slbs/restartSlbMasterProcess`, data)
}



// WEBPACK FOOTER //
// ./src/api/slb.js